/* eslint-disable-next-line import/no-unassigned-import, unicorn/no-unnecessary-polyfills -- polyfill by design */
import 'core-js/actual';
import moengage from '@moengage/web-sdk';
import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';

import App from './App';
import { I18nProvider } from './i18n/root-provider';
import { getRuntimeConfig } from './utils/config';

const config = getRuntimeConfig();

// Initialize MoEngage
moengage.initialize({
  app_id: config.VITE_MOENGAGE_APP_ID,
  ...(config.VITE_MOENGAGE_PROJECT_ID ? { project_id: config.VITE_MOENGAGE_PROJECT_ID } : {}),
  cluster: config.VITE_MOENGAGE_CLUSTER,
  useLatest: config.VITE_MOENGAGE_USE_LATEST === 'true',
  debug_logs: config.VITE_MOENGAGE_DEBUG_LOG === 'true' ? 1 : 0,
});

const app = document.querySelector('#app');
const root = app && createRoot(app);
ReactModal.setAppElement('#app');
root?.render(
  <I18nProvider>
    <App />
  </I18nProvider>
);
